const isUndefined = (x) => x === undefined;
export default isUndefined;
